import React, { Component} from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
// import { Link } from 'react-router';

import { downloadScheduleRoom } from './actions';
import './style.css';


class ScheduleRoom extends Component {

  componentWillMount() {
    let room = {};
    room.id = parseInt(window.location.pathname.split('/')[2], 10);
    if (room.id) {
      this.props.downloadScheduleRoom(room);
    }
    window.scrollTo(0, 0);
  }

  _createScheduleRoom = (room) => {
    let slides;
    let videos;
    console.log(room);
    slides = room.speakerShortViews.map(slide => {
      return <a href='https://yadi.sk/d/uEIOCu4i3UdTcU/2017-осень' target='_blank' className='room__media-presentation'>презентация доклада</a>;
    });
    console.log(slides);
    videos = room.creativeVideoViews.map(video => {
      return <iframe key={video.url} src={video.url} className='room__media-element' allowFullScreen='allowfullscreen'/>
    });
    return (
      <div className='room__event' key={room.roomEventShortView.idStr}>
        <div className='room__event-title'>{room.roomEventShortView.title}</div>
        <div className='room__time'>{room.eventDay + ' ' + room.startTime + '-' + room.endTime}</div>
        <div className='room__event-desc'>{room.roomEventShortView.description}</div>
        <div className='room__media'>
          {slides}
          {videos}
        </div>
      </div>
    );
  }
  _createSpeakersRoom = (speakers) => {
    return speakers.map(speaker => {
      return (
        <div className='speaker__schedule-info'>
          <img className='speaker__photo' src={speaker.pictureUrl} alt={speaker.userView.fullName} />
          <div className='speaker__name'>
            <a href={'/speaker?id=' + speaker.idStr} className='speaker__name'>
              {speaker.userView.fullName}
            </a>
          </div>
          <div className='speaker__position'>
            <a target='_blank' className='speaker__company' href={speaker.company.url}>
              {speaker.company.name}
            </a>
            , {speaker.jobPosition}
            , {speaker.userView.cityName}
          </div>
        </div>
      );
    });
  }

  render() {
    let speakers;
    let bodyRoom;
    if (Object.keys(this.props.roomEventView).length > 0) {
      speakers = this._createSpeakersRoom(this.props.roomEventView.speakerShortViews);
      bodyRoom = this._createScheduleRoom(this.props.roomEventView);
    }
    return (
      <div className='schedule'>
        <div className='schedule__container'>
          <div className='schedule__speakers'>{speakers}</div>
          {bodyRoom}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    roomEventView: state.schedule.roomEventView
  }
};

const mapDispatchToProps = (dispatch) => ({
  downloadScheduleRoom: bindActionCreators(downloadScheduleRoom, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps, null, {pure: false})(ScheduleRoom);



// WEBPACK FOOTER //
// ./src/schedule-page/ScheduleRoom.js